export const DATABASE_TABLE_TOP_ID = 'table-top'
